import type C1_EloItem from "../model/C1_EloItem";
import { C1_Consumer } from "../model/C1_Consumer";
import { lightGroupCount, lightGroupRows } from "../furniture/C1_lightGroup";

/** Visual instances share one consumer; only the original instance owns a connection anchor. */
export function lightGroupPlanInstances(item: C1_EloItem, technicalMode: boolean, rotation: number, reflect: boolean,
  props: Record<string, number> = {}) {
  const position = item.displayPosition ?? item.evaluatedAbsolutePosition;
  const instances = [{ item, position, suffix: "" }];
  const group = item instanceof C1_Consumer ? item.lightGroup : undefined;
  if (!technicalMode || !group || !position) return instances;
  const values = { ...group.baseProps, ...props };
  const columns = lightGroupCount(values.count), rows = lightGroupRows(values.effectiveRows ?? values.rows);
  const radians = rotation * Math.PI / 180;
  let additionalIndex = 0;
  for (let row = 0; row < rows; row++) for (let column = 0; column < columns; column++) {
    const x = (columns <= 1 ? 0 : column * values.width / (columns - 1)) * (reflect ? -1 : 1);
    const y = rows <= 1 ? 0 : row * values.height / (rows - 1);
    if (row === 0 && column === 0) continue;
    // a..z, aa..az, ... also supports large arrays.
    let suffix = "", number = additionalIndex++;
    do { suffix = String.fromCharCode(97 + number % 26) + suffix; number = Math.floor(number / 26) - 1; } while (number >= 0);
    instances.push({ item, suffix, position: {
      x: position.x + x * Math.cos(radians) - y * Math.sin(radians),
      y: position.y + x * Math.sin(radians) + y * Math.cos(radians),
    } });
  }
  return instances;
}
